/*
 * @Description:
 * @Date: 2021-06-17 15:05:33
 */

export default {
  serviceScale: {
    label: '服务费率',
    prop: 'serviceScale',
    formatter(r, c, v) {
      return !+v ? '-' : v + '%';
    }
  }
};
